export function OutlineMaleIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_29848_87294)">
        <path
          d="M9.6545 20.0014C13.0236 20.0014 15.7548 17.2702 15.7548 13.9011C15.7548 10.532 13.0236 7.80078 9.6545 7.80078C6.2854 7.80078 3.5542 10.532 3.5542 13.9011C3.5542 17.2702 6.2854 20.0014 9.6545 20.0014Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M14.1892 9.36561L19.965 3.58984"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M19.9999 9.40062V3.55469H14.4785"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_29848_87294">
          <rect width={width} height={height} fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
}
